// Maquina - Unified JavaScript Entry Point
// Combines Marketing, Blog, and Documentation functionality
import "$styles/index.css"

import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

// Import bridgetown-quick-search (Lunr.js powered search for documentation)
import "bridgetown-quick-search"

// Initialize Stimulus
const application = Application.start()
application.debug = false
window.Stimulus = application

// Import all controllers
import MobileNavController from "./controllers/mobile_nav_controller"
import ThemeController from "./controllers/theme_controller"
import ClipboardController from "./controllers/clipboard_controller"
import CodeTabsController from "./controllers/code_tabs_controller"
import CardHoverController from "./controllers/card_hover_controller"
import TocController from "./controllers/toc_controller"
import CollapsibleController from "./controllers/collapsible_controller"
import CodeCopyController from "./controllers/code_copy_controller"
import PreviewController from "./controllers/preview_controller"
import BlogFilterController from "./controllers/blog_filter_controller"

// Register all controllers
application.register("mobile-nav", MobileNavController)
application.register("theme", ThemeController)
application.register("clipboard", ClipboardController)
application.register("code-tabs", CodeTabsController)
application.register("card-hover", CardHoverController)
application.register("toc", TocController)
application.register("collapsible", CollapsibleController)
application.register("code-copy", CodeCopyController)
application.register("preview", PreviewController)
application.register("blog-filter", BlogFilterController)

// Press "/" to focus the documentation search (no-op on pages without it)
document.addEventListener("keydown", (event) => {
  if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey) return

  const active = document.activeElement
  if (active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA" || active.isContentEditable)) return

  const searchInput = document.querySelector("bridgetown-search-form input")
  if (!searchInput) return

  event.preventDefault()
  searchInput.focus()
})

// Smooth scroll for anchor links
document.addEventListener("click", (event) => {
  const link = event.target.closest('a[href^="#"]')
  if (!link) return

  const targetId = link.getAttribute("href").slice(1)
  const target = document.getElementById(targetId)

  if (target) {
    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
    history.pushState(null, null, `#${targetId}`)
  }
})

// Intersection Observer for scroll-based animations (marketing)
const observeElements = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in")
        }
      })
    },
    {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    }
  )

  // Observe elements with data-animate attribute
  document.querySelectorAll("[data-animate]").forEach((el) => {
    observer.observe(el)
  })
}

// Run on page load and Turbo navigation
document.addEventListener("turbo:load", observeElements)
document.addEventListener("DOMContentLoaded", observeElements)
